export default __webpack_public_path__ + "static/tropical_charm-419233976b741b45ca550439c73a9272.png";